export default __webpack_public_path__ + "static/media/c coding group button@2x.d1ba6ac1.png";